<template>
  <b-card-code title="Personas">
    <h3>{{ this.event.Aforo_name }}</h3>
    <h5>{{ this.event.pkid_mxs_event }} -> {{ this.event.event_name }}</h5>
    <div class="d-flex justify-content-end flex-wrap">
      <b-form-group>
        <b-input-group>
          <div class="d-flex justify-content-between">
            <b-input-group>
              <b-button
                variant="outline-primary"
                class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                to="/events">
                <!-- , params: { idEvent: data.idEvent} -->
                <feather-icon
                  icon="ArrowLeftCircleIcon"
                  class="mr-0 mr-sm-50"></feather-icon>
                Volver atrás
              </b-button>
            </b-input-group>
          </div>
          <b-dropdown
            v-if="$can('manage', 'PersonsActions')"
            text="Acciones"
            variant="primary"
            right>
            <b-dropdown-item
              v-if="$can('export', 'ExportPersons')"
              @click="onClickExport">
              <feather-icon icon="DownloadIcon" /> Exportar Fecha
            </b-dropdown-item>
            <b-dropdown-item
              v-if="$can('export', 'ExportPersonsAccess')"
              @click="onClickExportSCA">
              <feather-icon icon="DownloadCloudIcon" /> Exportar Fecha Acceso
            </b-dropdown-item>
            <b-dropdown-item
              v-if="$can('import', 'ImportPersons')"
              :to="{ name: 'importfiles', params: { idEvent: this.idEvent } }">
              <feather-icon icon="UploadIcon" /> Importar Archivo de Personas
            </b-dropdown-item>
            <b-dropdown-item
              v-if="$can('delete', 'DeletePerson')"
              @click="onClickDeletePersons">
              <feather-icon icon="Trash2Icon" /> Eliminar Personas
            </b-dropdown-item>
            <b-dropdown-item
              v-if="$can('create', 'AddPerson')"
              @click="createDraftPerson">
              <feather-icon icon="UserPlusIcon" /> Nueva Persona
            </b-dropdown-item>
          </b-dropdown>
        </b-input-group>
      </b-form-group>
    </div>
    <vue-good-table
      ref="table"
      :select-options="{ enabled: true, disableSelectInfo: true }"
      :columns="columns"
      :rows="rows"
      :search-options="{ enabled: true, externalQuery: searchTerm }"
      :pagination-options="{ enabled: true, perPage: pageLength }">
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'DocStatus'">
          <b-badge :variant="statusVariant(props.row.DocStatus)">
            {{ props.row.DocStatus }}
          </b-badge>
        </span>

        <span v-else-if="props.column.field === 'details'">
          <span>
            <b-button
              variant="primary"
              v-if="$can('edit', 'EditPerson')"
              :to="{
                name: 'details',
                params: { id: props.row.pkid_accreditation_document_detail },
              }"
              class="btn-icon">
              <!-- , idEvent: data.idEvent -->
              <feather-icon icon="FileIcon" />
            </b-button>
          </span>
        </span>
      </template>

      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Showing 1 to </span>
            <b-form-select
              v-model="pageLength"
              :options="['15', '50', '100', '300', '3000']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              " />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card-code>
</template>

<script>
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import {
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BButton,
  BInputGroup,
  BFormCheckbox,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import router from "@/router";
import axios from "@/libs/axios";
import XLSX from "xlsx";
import { decryptString, encryptString } from "@/libs/crypto";

export default {
  components: {
    BCardCode,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BButton,
    BInputGroup,
    BFormCheckbox,
  },
  data() {
    return {
      pageLength: 50,
      dir: false,
      columns: [
        { label: "Detalles", field: "details", tdClass: "text-center" },
        {
          label: "Nombre",
          field: "Nom_titular",
          filterOptions: { enabled: true, placeholder: "Buscar Nombre" },
        },
        {
          label: "Apellido1",
          field: "Cognom1_titular",
          filterOptions: { enabled: true, placeholder: "Buscar Apellido1" },
        },
        {
          label: "Apellido2",
          field: "Cognom2_titular",
          filterOptions: { enabled: true, placeholder: "Buscar Apellido2" },
        },
        {
          label: "DOI",
          field: "DNI",
          filterOptions: { enabled: true, placeholder: "Buscar DOI" },
        },
        {
          label: "Matricula",
          field: "Matricula",
          filterOptions: { enabled: true, placeholder: "Buscar Matricula" },
        },
        {
          label: "Código de Barras (Pulsera)",
          field: "Cod_Barras",
          filterOptions: {
            enabled: true,
            placeholder: "Buscar Código de barras (Pulsera)",
          },
        },
        {
          label: "Acceso SCA",
          field: "AccesSCA",
          filterOptions: { enabled: true, placeholder: "Buscar SCA Acceso" },
        },
        {
          label: "Empresa",
          field: "Empresa_nom",
          filterOptions: { enabled: true, placeholder: "Buscar Empresa" },
        },
        {
          label: "EstadoDocumento",
          field: "DocStatus",
          filterOptions: { enabled: true, placeholder: "Buscar EstadoDocumento" },
        },
        {
          label: "EstadoDocumentoSCA",
          field: "DocStatusSCA",
          filterOptions: { enabled: true, placeholder: "Buscar EstadoDocumentoSCA" },
        },
        {
          label: "ID_Doc",
          field: "pkid_accreditation_document_detail",
          filterOptions: { enabled: true, placeholder: "Buscar ID" },
        },
        {
          label: "ID_Accred",
          field: "fkid_accreditation_document",
          filterOptions: { enabled: true, placeholder: "Buscar ID" },
        },
      ],
      rows: [],
      sca: [],
      eventName: "",
      searchTerm: "",
      event: [],
      idEvent: router.currentRoute.params.idEvent,
      selectedRows: [],
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        OK: "light-success",
        OK_Exit: "light-warning",
        "OK_Exit+": "light-warning",
        OK_entered: "light-info",
        ERROR: "light-danger",
        "INCORRECTO No es válido realizar movimineto de salida": "light-danger",
        REPETIT: "light-danger",
        "Fecha de vencimiento fuera de plazo": "light-danger",
        "Fecha de fin de validez fuera de plazo": "light-danger",
        "Fecha de caducidad fuera de plazo": "light-danger",
        "No existe documento en detalle del evento": "light-danger",
        "En baja: Entrada a baja": "light-danger",
        "ERROR DNI ACREDITACIÓN duplicado": "light-danger",
        "ACREDITACIÓN Anulada": "light-danger",
        "DENEGADA ACREDITACIÓN": "light-danger",
        "ELIMINADO - NO PDA": "light-primary",
      };
      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        this.dir = true;
        return this.dir;
      }

      this.dir = false;
      return this.dir;
    },
  },
  methods: {
    onClickExport() {
      const ws = XLSX.utils.json_to_sheet(this.rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, "Persons_" + this.eventName + ".xlsx");
    },
    onClickExportSCA() {
      const ws = XLSX.utils.json_to_sheet(this.sca);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, "AccesRegistry_" + this.eventName + ".xlsx");
    },
    async onClickDeletePersons() {
      const selectedRows = this.$refs["table"].selectedRows;
      let error = false;
      selectedRows.forEach((element) => {
        if (element.DocStatusSCA !== null && element.DocStatusSCA !== "") {
          error = true;
        }
      });

      if (selectedRows.length <= 0) {
        const variant = "danger";
        this.$bvToast.toast("No se han seleccionado registros para eliminar", {
          title: `` + "Error",
          variant,
          solid: true,
        });
      } else if (!error) {
        const ids = selectedRows
          .map((row) => row.pkid_accreditation_document_detail)
          .toString();
        await axios
          .delete("/accred-doc-detailed?ids=" + ids)
          .then(async () => {
            const variant = "success";
            this.$bvToast.toast("Persona/s eliminada/s con éxito", {
              title: "Success",
              variant,
              solid: true,
            });
            await axios
              .get(
                "/event?pkid_mxs_event=" + router.currentRoute.params.idEvent
              )
              .then((results) => {
                this.event = results.data[0];
                this.eventName = results.data[0].event_name;
                this.eventName = this.eventName.trim();
              })
              .catch((error) => {
                const variant = "danger";
                this.$bvToast.toast("Fallo al conectar", {
                  title: `` + error,
                  variant,
                  solid: true,
                });
              });

            await axios
              .get(
                "/accred-doc-detailed?fkid_mxs_event=" +
                  router.currentRoute.params.idEvent
              )
              .then((results) => {
                this.rows = results.data;
              })
              .catch((error) => {
                const variant = "danger";
                this.$bvToast.toast("Fallo al conectar", {
                  title: `` + error,
                  variant,
                  solid: true,
                });
              });

            await axios
              .get(
                "/accred-sca-registry?fkid_mxs_event=" +
                  router.currentRoute.params.idEvent
              )
              .then((results) => {
                this.sca = results.data;
              })
              .catch((error) => {
                const variant = "danger";
                this.$bvToast.toast("Fallo al conectar", {
                  title: `` + error,
                  variant,
                  solid: true,
                });
              });
          })
          .catch((error) => {
            const variant = "danger";
            this.$bvToast.toast("Fallo al conectar", {
              title: `` + error,
              variant,
              solid: true,
            });
          });
      } else {
        const variant = "danger";
        this.$bvToast.toast("Verifique que DocStatusSCA sea nulo", {
          title: `` + "No se pudieron eliminar los registros seleccionados",
          variant,
          solid: true,
        });
      }
    },

    async createDraftPerson() {
      try {
        await axios.delete("/personsDelete", {
          params: {
            fkid_accreditation_process_type: 1
          }
        });
        

        const payload = {
          fkid_mxs_event: this.idEvent,
          ID_usuari_creacio:
            decryptString(localStorage.getItem("idUser")) || "unknown",
        };

        const { data } = await axios.post("/personsDraft", payload);

        // Redirige al formulario con todos los datos necesarios
        this.$router.push({
          name: "create-person",
          params: {
            idEvent: this.idEvent,
          },
          query: {
            id: data.detailId, // <- este ahora sí te llegará desde el backend
          },
        });
      } catch (err) {
        console.error("Error creando draft de persona:", err);
      }
    },
  },
  async created() {
    await axios
      .get("/event?pkid_mxs_event=" + router.currentRoute.params.idEvent)
      .then((results) => {
        this.event = results.data[0];
        this.eventName = results.data[0].event_name;
        this.eventName = this.eventName.trim();
      })
      .catch((error) => {
        const variant = "danger";
        this.$bvToast.toast("Fallo al conectar", {
          title: `` + error,
          variant,
          solid: true,
        });
      });

    await axios
      .get(
        "/accred-doc-detailed?fkid_mxs_event=" +
          router.currentRoute.params.idEvent
      )
      .then((results) => {
        this.rows = results.data;
      })
      .catch((error) => {
        const variant = "danger";
        this.$bvToast.toast("Fallo al conectar", {
          title: `` + error,
          variant,
          solid: true,
        });
      });

    await axios
      .get(
        "/accred-sca-registry?fkid_mxs_event=" +
          router.currentRoute.params.idEvent
      )
      .then((results) => {
        this.sca = results.data;
      })
      .catch((error) => {
        const variant = "danger";
        this.$bvToast.toast("Fallo al conectar", {
          title: `` + error,
          variant,
          solid: true,
        });
      });
  },
  mounted() {
    if (localStorage.getItem("accessToken") === null) {
      this.$router.go(0);
    }
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
// .vgt-checkbox-col input[type="checkbox" i] {

// }
</style>
